import React from "react";
import GenericList from "@/pages/GenericList";
import { useLang } from "@/context/LangContext";

export function FollowUps() {
  const { t } = useLang();
  return <GenericList kind="follow_ups" testKey="follow-ups"
    title="Follow-ups" subtitle="Track outreach and next actions with clients"
    newLabel="New follow-up"
    fields={[
      { key: "client", label: "Client / Lead" },
      { key: "next_action", label: "Next action" },
      { key: "due_date", label: "Due", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["pending", "done", "cancelled"] },
      { key: "channel", label: "Channel", type: "select", options: ["call", "email", "whatsapp", "meeting", "other"] },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}

export function Notes() {
  return <GenericList kind="notes" testKey="notes"
    title="Notes" subtitle="Meeting notes, quick captures, ideas"
    newLabel="New note"
    fields={[
      { key: "title", label: "Title" },
      { key: "tag", label: "Tag" },
      { key: "author", label: "Author" },
      { key: "date", label: "Date", type: "date" },
      { key: "body", label: "Note", type: "textarea", wide: true },
    ]}
  />;
}

export function Branding() {
  return <GenericList kind="branding" testKey="branding"
    title="Branding" subtitle="Logo, identity and brand system projects"
    newLabel="New brand project"
    fields={[
      { key: "brand", label: "Brand" },
      { key: "client", label: "Client" },
      { key: "deliverable", label: "Deliverable", type: "select", options: ["logo", "identity", "guidelines", "naming", "other"] },
      { key: "status", label: "Status", type: "select", options: ["research", "concept", "revision", "delivered"] },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}

export function GraphicDesign() {
  return <GenericList kind="graphic_design" testKey="graphic-design"
    title="Graphic Design" subtitle="Design assets and campaigns"
    newLabel="New design task"
    fields={[
      { key: "title", label: "Title" },
      { key: "client", label: "Client" },
      { key: "asset", label: "Asset type", type: "select", options: ["poster", "social", "print", "packaging", "presentation", "other"] },
      { key: "due_date", label: "Due", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["queued", "in_progress", "review", "approved"] },
    ]}
  />;
}

export function ContentCalendar() {
  return <GenericList kind="content" testKey="content"
    title="Content Calendar" subtitle="Editorial pipeline for social & blog"
    newLabel="New content"
    fields={[
      { key: "title", label: "Title" },
      { key: "channel", label: "Channel", type: "select", options: ["Instagram", "Facebook", "TikTok", "LinkedIn", "X", "Blog", "Newsletter"] },
      { key: "publish_at", label: "Publish", type: "datetime-local" },
      { key: "status", label: "Status", type: "select", options: ["idea", "draft", "review", "scheduled", "published"] },
      { key: "author", label: "Author" },
      { key: "brief", label: "Brief", type: "textarea", wide: true },
    ]}
  />;
}

export function Printing() {
  return <GenericList kind="printing" testKey="printing"
    title="Printing Services" subtitle="Print orders and jobs"
    newLabel="New print order"
    fields={[
      { key: "item", label: "Item" },
      { key: "material", label: "Material" },
      { key: "quantity", label: "Quantity", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["quoted", "in_production", "ready", "delivered"] },
      { key: "notes", label: "Notes", type: "textarea", wide: true },
    ]}
  />;
}
